import * as React from 'react';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserGroup,
  faHouse,
  faRankingStar,
  faBookOpen,
  faNewspaper,
  faGun,
  faSpaghettiMonsterFlying,
  faLocationDot
} from '@fortawesome/free-solid-svg-icons';
import { useLocation } from '@reach/router';
import { Nav } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../state/Store';
import { ToggleMenu } from '../../../layout/actions/Layout.actions';

export const WWMenu: React.FC = () => {
  const pathFragments = useLocation()
    .pathname.split('/')
    .filter((p) => p && p.trim().length > 0);
  const activeKey = pathFragments.length < 1 ? 'home' : pathFragments[0];

  const model = useSelector((state: RootState) => ({
    layout: state.layout
  }));

  const dispatch = useDispatch();

  const handleOnClick = () => {
    if (model.layout.isMenuVisible === true) {
      dispatch(ToggleMenu());
    }
  };

  return (
    <Nav className="ms-auto" activeKey={activeKey}>
      <Link to="/wuthering-waves/">
        <Nav.Link as="span" eventKey="home" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faHouse} width="18" /> <span>Home</span>
        </Nav.Link>
      </Link>
      <Link to="/wuthering-waves/characters">
        <Nav.Link as="span" eventKey="characters" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faUserGroup} width="18" />{' '}
          <span>Characters</span>
        </Nav.Link>
      </Link>
      <Link to="/wuthering-waves/echoes">
        <Nav.Link as="span" eventKey="echoes" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faSpaghettiMonsterFlying} width="18" />{' '}
          <span>Echoes</span>
        </Nav.Link>
      </Link>
      <Link to="/wuthering-waves/weapons">
        <Nav.Link as="span" eventKey="weapons" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faGun} width="18" /> <span>Weapons</span>
        </Nav.Link>
      </Link>
      <Link to="/wuthering-waves/tier-list">
        <Nav.Link as="span" eventKey="tier-list" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faRankingStar} width="18" />{' '}
          <span>Tier list</span>
        </Nav.Link>
      </Link>
      <hr />
      <Link to="/wuthering-waves/guides/">
        <Nav.Link as="span" eventKey="guides" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faBookOpen} width="18" /> <span>Guides</span>
        </Nav.Link>
      </Link>
      <a href="https://www.ghzs666.com/wutheringwaves-map#/" target="_blank">
        <Nav.Link as="span" eventKey="blog">
          <FontAwesomeIcon icon={faLocationDot} width="18" /> <span>Map</span>
        </Nav.Link>
      </a>
      <hr />
      <a
        href="https://blog.prydwen.gg/category/wuthering-waves/"
        target="_blank"
      >
        <Nav.Link as="span" eventKey="blog">
          <FontAwesomeIcon icon={faNewspaper} width="18" /> <span>Blog</span>
        </Nav.Link>
      </a>
    </Nav>
  );
};
